module.exports = __webpack_public_path__ + "img/app-field-collection.dfeaebd6.webp";